import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PainelManutencoesService {

  constructor(private readonly http: HttpClient) { }

  getEnderecos(idEmpresa: string, pagina: number, tamanho: string, campoEntrada: string) {

    let input: string;
    if(campoEntrada) {
      input = `campoEntrada=${campoEntrada}&`;
    } else { input = '';}

    const url: string = `/apiconnect/orders/maintenance/from-to/addresses/${idEmpresa}/companies?${input}pagina=${pagina}&tamanho=${tamanho}`;

    return this.http.get(url);
  }

  deleteEnderecoUnico(idEmpresa: string, codigoCepArquivo: string) {
    const url: string = `/apiconnect/orders/maintenance/from-to/addresses/${idEmpresa}/companies?codigosCepArquivo=${codigoCepArquivo}`;

    return this.http.delete(url);
  }

  // Não achei essa URL nova, mas seguindo o padrao tira a palavra ="codigosCepArquivo" e manda um array, caso nao de certo, tente remover a em baixo
  deleteAllEnderecos(idEmpresa: string, codigosEnderecos: string) {
    const url: string = `/apiconnect/orders/maintenance/from-to/addresses/${idEmpresa}/companies?${codigosEnderecos}`;

    return this.http.delete(url);
  }

  // PRODUTOS

  getProdutos(idEmpresa: string, pagina: number, tamanho: string, campoEntrada: string) {

    let input: string;
    if(campoEntrada) {
      input = `campoEntrada=${campoEntrada}&`;
    } else { input = '';}

    const url: string = `/apiconnect/orders/maintenance/from-to/products/${idEmpresa}/companies?${input}pagina=${pagina}&tamanho=${tamanho}`;

    return this.http.get(url);
  }

  deleteProdutoUnico(idEmpresa: string, codigoBeneficioArquivo: string) {
    const url: string = `/apiconnect/orders/maintenance/from-to/products/${idEmpresa}/companies?codigosBeneficioArquivo=${codigoBeneficioArquivo}`;

    return this.http.delete(url);
  }

  // Caso de erro, tira o "codigoBeneficioArquivo" e só envia o array de codigos.
  deleteAllProdutos(idEmpresa: string, codigosProdutos: string) {
    const url: string = `/apiconnect/orders/maintenance/from-to/products/${idEmpresa}/companies?${codigosProdutos}`;

    return this.http.delete(url);
  }
  
}
